import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Typography} from "@material-ui/core";

class TitleSectionComponent extends Component {
    render() {
        const { title, subtitle } = this.props; // Destructure props

        return (
            <div>
                <Typography variant={'h6'} color={'secondary'}>
                    {title} {/* Use the title prop */}
                </Typography>
                <Typography variant={'subtitle2'} color={'secondary'}>
                    {subtitle} {/* Use the subtitle prop */}
                </Typography>
            </div>
        );
    }
}

TitleSectionComponent.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
};

export default TitleSectionComponent;